import { Utility } from './../../../shared/utility';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { ReadConfigService } from './../../../shared/services/common/read-config.service';
import { UsersService } from './../../../shared/services/common/users.service';
import { AdjustmentService } from './../../../shared/services/adjustments/adjustment.service';
import { DisplayNotificationService } from './../../../shared/services/common/notification.service';
import { Component, OnInit, AfterViewChecked, Input, Output, EventEmitter } from '@angular/core';
import { State, CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-view-adjustment-reports',
  templateUrl: './view-adjustment-reports.component.html',
  styleUrls: ['./view-adjustment-reports.component.css']
})
export class ViewAdjustmentReportsComponent implements OnInit, AfterViewChecked {
  initialLoading = false;
  gridLoaded: any;
  operators: any;
  selectedTab: number;
  cssId: string;
  deleteReportDialog: boolean;
  loading: boolean;
  removeRecord: any;
  filters: CompositeFilterDescriptor;
  state: State = {
    skip: 0,
    take: 10,
    sort: []
  };
  ownersList: any;
  filterOwnerRecords: any;
  config: any;
  inputData: { userInfo: any, adjType: string };
  reportsData: {
    tabTitle: string;
    adjType: string;
    data: [];
    show: boolean;
  }[];

  @Input() set accessOperators(opts: any) {
    this.operators = opts;
  }
  @Input() set ownerRecords(owners: any) {
    if (owners) {
      this.ownersList = owners;
      this.filterOwnerRecords = owners.slice();
    }
  }
  @Output() loadViewReport: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
    private authService: AuthService,
    private usersService: UsersService,
    private adjustmentService: AdjustmentService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService,
  ) { }

  ngOnInit() {
    this.config = this.readConfigService.getAdjustmentv2Text();
    this.notificationService.setUpLoading(true);
    this.inputData = {
      userInfo: this.usersService.UserInfo(),
      adjType: ''
    };
    this.getAllAdjReports();
  }

  ngAfterViewChecked() {
    this.setTabStripStyle();
  }

  getAllAdjReports() {
    this.notificationService.setUpLoading(true);
    this.initialLoading = true;
    this.reportsData = [{
      tabTitle: 'Not Submitted',
      adjType: 'NotSubmitted',
      data: [],
      show: false
    },
    {
      tabTitle: 'Submitted',
      adjType: 'Submitted',
      data: [],
      show: false
    }];
    this.selectedTab = 0;
    this.gridLoaded = { a: false, b: false };
    this.getAdjustmentRecords(true);
  }

  getAdjustmentRecords(isSubmit: boolean) {
    const index = isSubmit ? 0 : 1;
    this.inputData.adjType = this.reportsData[index].adjType;
    this.adjustmentService.getPayrollAdjRecords(this.inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.adjustments) {
        const orgValue = JSON.parse(this.authService.decryptText(Utility.removeQuotes(sessionStorage.getItem('current_user'))));
        data.adjustments.forEach((element) => {
          element.createdDate = new Date(element.createdDate);
          element.modifiedDate = new Date(element.modifiedDate);
          element.isAuthorizedOwner = (element.ownerId === Number(orgValue.Id));
          element.formatAmount = Utility.checkNegativeAmount(element.totalContributions);
        });
        this.reportsData[index].data = data.adjustments;
      } else if (data && data.statusCode === 204) {
        this.reportsData[index].data = [];
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.gridLoaded[index === 0 ? 'a' : 'b'] = true;
      this.reportsData[index].show = true;
      this.notificationService.setUpLoading(false);
      this.initialLoading = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.gridLoaded[index === 0 ? 'a' : 'b'] = true;
        this.reportsData[index].show = true;
        this.notificationService.setUpLoading(false);
        this.initialLoading = false;
        this.notificationService.setErrorNotification();
      });
  }

  onTabSelect(event: any) {
    if (event) {
      this.selectedTab = event.index;
      switch (this.selectedTab) {
        case 1:
          if (!this.gridLoaded.b) {
            this.notificationService.setUpLoading(true);
            this.getAdjustmentRecords(false);
          }
          break;
        default: {
          if (!this.gridLoaded.a) {
            this.getAdjustmentRecords(true);
          }
          break;
        }
      }
    }
  }

  setTabStripStyle() {
    const allDetails = document.querySelectorAll('.k-tabstrip');
    if (allDetails && allDetails.length > 0) {
      allDetails.forEach(details => {
        const firstChild = details.firstElementChild;
        if (firstChild && firstChild.children && firstChild.children.length > 1) {
          const elArr = Array.from(firstChild.children) as Array<HTMLElement>;
          elArr.forEach(element => {
            element.style.width = 100 / firstChild.children.length + '%';
          });
        }
      });
    }
  }

  onOwnerSelection(value: any, adjRecordId: any) {
    this.notificationService.setUpLoading(true);
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      adjustmentId: adjRecordId,
      ownerId: value.id,
    };
    this.adjustmentService.updateAdjustmentOwner(inputData).subscribe((response: any) => {
      if (response && response.statusCode === 200) {
        this.notificationService.setUpNotification({ message: response.message, success: true });
      } else {
        this.notificationService.setUpNotification({ message: response.message, success: false });
      }
      this.getAdjustmentRecords(true);
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  handleFilter(value: any) {
    this.ownersList = value ? this.filterOwnerRecords.filter((s: any) => s.fullName.toLowerCase().indexOf(value.toLowerCase()) !== -1)
      : this.filterOwnerRecords.slice();
  }

  editHandler(editEvent: any) {
    this.loadViewReport.emit(editEvent);
  }

  removeHandler(removeEvent: any) {
    this.removeRecord = removeEvent;
    this.deleteReportDialog = true;
  }

  deleteAdjReport() {
    this.loading = true;
    this.notificationService.setUpLoading(true);
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      adjustmentId: this.removeRecord.dataItem.id
    };
    this.adjustmentService.deleteAdjReport(inputData).subscribe(response => {
      if (response && response.success) {
        this.getAdjustmentRecords(true);
        this.notificationService.setUpNotification(response);
      } else if (response && !response.success) {
        this.notificationService.setUpNotification(response);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.deleteReportDialog = false;
      this.notificationService.setUpLoading(false);
      this.loading = false;
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.loading = false;
        this.deleteReportDialog = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

}
